// Debug utility to view stored errors in browser console
// You can run this in the browser console to see all captured errors

window.showStoredErrors = () => {
  const reactErrors = JSON.parse(localStorage.getItem('appErrors') || '[]');
  const globalErrors = JSON.parse(localStorage.getItem('globalErrors') || '[]');

  console.group('🐛 Stored Application Errors');

  if (reactErrors.length > 0) {
    console.group('React Component Errors');
    reactErrors.forEach((error, index) => {
      console.group(`Error ${index + 1} - ${error.timestamp}`);
      console.log('Error ID:', error.errorId);
      console.log('Message:', error.message);
      console.log('URL:', error.url);
      console.log('User Agent:', error.userAgent);
      console.log('Viewport:', error.viewport);
      if (error.stack) {
        console.log('Stack Trace:', error.stack);
      }
      if (error.componentStack) {
        console.log('Component Stack:', error.componentStack);
      }
      console.groupEnd();
    });
    console.groupEnd();
  } else {
    console.log('✅ No React component errors found');
  }

  if (globalErrors.length > 0) {
    console.group('Global JavaScript Errors');
    globalErrors.forEach((error, index) => {
      console.group(`Error ${index + 1} - ${error.timestamp}`);
      console.log('Type:', error.type);
      console.log('Message:', error.message);
      console.log('URL:', error.url);
      if (error.filename) {
        console.log('File:', error.filename);
        console.log('Line:', `${error.lineno}:${error.colno}`);
      }
      if (error.stack && error.stack !== 'No stack trace available') {
        console.log('Stack Trace:', error.stack);
      }
      console.groupEnd();
    });
    console.groupEnd();
  } else {
    console.log('✅ No global JavaScript errors found');
  }

  console.groupEnd();

  return {
    reactErrors,
    globalErrors,
    totalErrors: reactErrors.length + globalErrors.length,
  };
};

window.clearStoredErrors = () => {
  localStorage.removeItem('appErrors');
  localStorage.removeItem('globalErrors');
  console.log('🧹 All stored errors cleared');
};

window.exportErrorsAsText = () => {
  const reactErrors = JSON.parse(localStorage.getItem('appErrors') || '[]');
  const globalErrors = JSON.parse(localStorage.getItem('globalErrors') || '[]');

  let output = '=== APPLICATION ERROR REPORT ===\n\n';
  output += `Generated: ${new Date().toISOString()}\n`;
  output += `Total Errors: ${reactErrors.length + globalErrors.length}\n\n`;

  if (reactErrors.length > 0) {
    output += '--- REACT COMPONENT ERRORS ---\n\n';
    reactErrors.forEach((error, index) => {
      output += `Error ${index + 1}:\n`;
      output += `ID: ${error.errorId}\n`;
      output += `Timestamp: ${error.timestamp}\n`;
      output += `Message: ${error.message}\n`;
      output += `URL: ${error.url}\n`;
      output += `User Agent: ${error.userAgent}\n`;
      output += `Viewport: ${error.viewport}\n`;
      if (error.stack) {
        output += `Stack Trace:\n${error.stack}\n`;
      }
      if (error.componentStack) {
        output += `Component Stack:\n${error.componentStack}\n`;
      }
      output += '\n---\n\n';
    });
  }

  if (globalErrors.length > 0) {
    output += '--- GLOBAL JAVASCRIPT ERRORS ---\n\n';
    globalErrors.forEach((error, index) => {
      output += `Error ${index + 1}:\n`;
      output += `Type: ${error.type}\n`;
      output += `Timestamp: ${error.timestamp}\n`;
      output += `Message: ${error.message}\n`;
      output += `URL: ${error.url}\n`;
      if (error.filename) {
        output += `File: ${error.filename}\n`;
        output += `Line: ${error.lineno}:${error.colno}\n`;
      }
      if (error.stack && error.stack !== 'No stack trace available') {
        output += `Stack Trace:\n${error.stack}\n`;
      }
      output += '\n---\n\n';
    });
  }

  // Copy to clipboard if possible
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(output).then(() => {
      console.log('📋 Error report copied to clipboard');
    });
  }

  return output;
};

console.log(`
🐛 Error Debug Utilities Loaded

Available commands:
• showStoredErrors() - View all captured errors
• clearStoredErrors() - Clear error storage  
• exportErrorsAsText() - Export errors as text report

Run any of these commands in the console to debug errors.
`);

export {}; // Make this a module
